import { useState, useEffect } from 'react';
import { DAV_APIS } from '../adapters';

let pagesData: any = [];

const useLandingPages = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [pages, setPages] = useState<any[]>([]);

  useEffect(() => {
    const fetchPages = async () => {
      if (!navigator.onLine) return;
      if (pagesData.length > 0) {
        setPages(pagesData);
        return;
      }
      setLoading(true);
      try {
        const res = await DAV_APIS.landingPages.getPages();
        setPages(res.data.pages);
        pagesData = res.data.pages;
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchPages();
  }, []);

  return {
    loading,
    pages,
  };
};

export default useLandingPages;
